import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

const revealUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.75,
      ease,
    },
  },
};

export default function UpComingEvents() {
  return (
    <main className="-mt-10 h-[calc(100vh-4.5rem)] min-h-[640px] overflow-hidden bg-[#F3FBFA] font-sans text-[#163C3B] dark:bg-[#141414] dark:text-white">
      <section className="relative flex h-full w-full items-center justify-center overflow-hidden">
        {/* PAGE BACKGROUND */}
        <div className="absolute inset-0 bg-[#F3FBFA] dark:bg-[#141414]" />

        <div className="absolute inset-y-0 left-0 w-[58%] bg-[#EAF6F4] dark:bg-[#191919]" />

        <div className="absolute left-[58%] top-0 hidden h-full w-px bg-[#B7D3CF]/60 dark:bg-zinc-800 lg:block" />

        {/* SUBTLE BACKGROUND DETAILS */}
        <div className="absolute -left-24 top-1/2 h-[380px] w-[380px] -translate-y-1/2 rounded-full border border-[#A7CBC6]/40 dark:border-zinc-800" />

        <div className="absolute -left-8 top-1/2 h-[260px] w-[260px] -translate-y-1/2 rounded-full border border-[#A7CBC6]/50 dark:border-zinc-800" />

        <div className="absolute right-[8%] top-[12%] h-[220px] w-[220px] rounded-full bg-[#D1BD3D]/10 blur-3xl dark:bg-[#D1BD3D]/5" />

        <div className="absolute bottom-[10%] left-[28%] h-[180px] w-[180px] rounded-full bg-[#6FA9A2]/10 blur-3xl dark:bg-[#6FA9A2]/5" />

        {/* EMPTY EVENT STATE */}
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-7 text-center sm:px-10"
        >
          <motion.p
            variants={revealUp}
            className="text-xs font-bold uppercase tracking-[0.3em] text-[#8F8120] dark:text-[#CDB937] sm:text-sm"
          >
            EthioCare Community Events
          </motion.p>

          <motion.div
            variants={revealUp}
            className="my-8 h-px w-20 bg-[#A18E1E] dark:bg-[#E2CD42]"
          />

          <motion.h1
            variants={revealUp}
            className="max-w-4xl text-5xl font-extrabold leading-[0.98] tracking-[-0.045em] text-[#163C3B] dark:text-white sm:text-6xl lg:text-7xl xl:text-[5.5rem]"
            style={{
              textShadow:
                "0 2px 3px rgba(17,63,61,0.12), 0 9px 24px rgba(17,63,61,0.05)",
            }}
          >
            No Upcoming Events
            <span className="mt-3 block text-[#A18E1E] dark:text-[#E2CD42]">
              Right Now
            </span>
          </motion.h1>

          <motion.p
            variants={revealUp}
            className="mt-8 max-w-2xl text-lg font-medium leading-relaxed text-[#476564] dark:text-gray-300 sm:text-xl lg:text-2xl"
          >
            More community events will be coming soon.
          </motion.p>

          <motion.p
            variants={revealUp}
            className="mt-3 max-w-xl text-sm font-semibold leading-relaxed text-[#617D7A] dark:text-gray-400 sm:text-base"
          >
            This page will be updated as soon as the next event is announced.
          </motion.p>

          <motion.div
            variants={revealUp}
            className="mt-10 flex items-center gap-4"
          >
            <span className="h-px w-12 bg-[#B7D3CF] dark:bg-zinc-700" />

            <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#8F8120] dark:text-[#CDB937]">
              Check Back Soon
            </span>

            <span className="h-px w-12 bg-[#B7D3CF] dark:bg-zinc-700" />
          </motion.div>
        </motion.div>

        {/* BOTTOM MESSAGE */}
        <p className="absolute bottom-7 right-7 hidden text-[10px] font-bold uppercase tracking-[0.25em] text-[#617D7A]/65 dark:text-white/40 sm:block">
          Together We Are Strong
        </p>
      </section>
    </main>
  );
}
